export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11059.66fb440a.jpg";